import script from "./TermsAndCondition.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsAndCondition.vue?vue&type=script&setup=true&lang=js"

import "./TermsAndCondition.vue?vue&type=style&index=0&id=fc27ff9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc27ff9e"]])

export default __exports__